import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import RealVenuePerformance from "./RealVenuePerformance";
import SaveBreakDown from "./SaveBreakDown";
import CategoryScore from "./CategoryScore";
import CustomerBehavior from "./CustomerBehavior";
import MarketIntelligence from "./MarketIntelligence";

type TabKey =
  | "Live"
  | "Save Break Down"
  | "Category Score"
  | "Customer Behavior"
  | "Market Intelligence";

const Analytics = () => {
  const location = useLocation();
  const venueId = location.state?.venueId;

  const [activeTab, setActiveTab] = useState<TabKey>("Live");

  const TABS = [
    { key: "Live", label: "Live" },
    { key: "Save Break Down", label: "Save Break Down" },
    { key: "Category Score", label: "Category Score" },
    { key: "Customer Behavior", label: "Customer Behavior" },
    { key: "Market Intelligence", label: "Market Intelligence" },
  ];

  const renderTab = () => {
    switch (activeTab) {
      case "Live":
        return <RealVenuePerformance venueId={venueId} />;

      case "Save Break Down":
        return <SaveBreakDown venueId={venueId} />;

      case "Category Score":
        return <CategoryScore venueId={venueId} />;

      case "Customer Behavior":
        return <CustomerBehavior venueId={venueId} />;

      case "Market Intelligence":
        return <MarketIntelligence venueId={venueId} />;

      default:
        return null;
    }
  };

  return (
    <div>
      {/* ===== TOP TABS ===== */}
      <div
        style={{
          display: "flex",
          gap: 12,
          borderBottom: "1px solid #E5E7EB",
          marginBottom: 24,
        }}
      >
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key as TabKey)}
            style={{
              padding: "10px 22px",
              border: "none",
              borderBottom:
                activeTab === t.key ? "3px solid #2563EB" : "3px solid transparent",
              background: "transparent",
              cursor: "pointer",
              fontWeight: 600,
              color: activeTab === t.key ? "#2563EB" : "#6B7280",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ===== TAB CONTENT ===== */}
      {renderTab()}
    </div>
  );
};

export default Analytics;
